// Each boarding gets at most one five-second lease. Staying aboard cannot renew it.
export class ElevatorReservation {
  constructor() {
    this.owner = null
    this.until = 0
    this.aboard = new Set()
  }

  update(ids, now, moving) {
    const previousOwner = this.owner
    const current = new Set(ids)
    if (this.owner && (now >= this.until || !current.has(this.owner))) {
      this.owner = null
      this.until = 0
    }
    for (const id of current) {
      if (!this.aboard.has(id) && !this.owner && !moving) {
        this.owner = id
        this.until = now + 5
      }
    }
    this.aboard = current
    return previousOwner !== this.owner
  }

  permits(id, now) { return !this.owner || now >= this.until || this.owner === id }
}
